import { PollingAbstractService } from '../../../shared/services/abstract/polling.abstract.service';
import { Injectable } from '@angular/core';
import { RingCentralExportDetails } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MigrationsRingCentralPollingService extends PollingAbstractService<RingCentralExportDetails> {
  baseUrl = '';

  setBaseUrl(tenantId: string, exportId: string): void {
    this.baseUrl = `/services/microsoft/migrations/tenants/${tenantId}/exports/ring-central/${exportId}`;
  }
}
